document.addEventListener("DOMContentLoaded", function () {
	const carousels = document.querySelectorAll(
		".carousel, .is-style-carousel",
	);

	carousels.forEach(function (carousel) {
		// Add Swiper container class

		carousel.classList.add("swiper");

		// Create swiper-wrapper

		const wrapper = document.createElement("div");

		wrapper.classList.add("swiper-wrapper");

		// Move all direct children into wrapper and add swiper-slide class

		Array.from(carousel.children).forEach((child) => {
			child.classList.add("swiper-slide");
			wrapper.appendChild(child);
		});

		// Remove all children from carousel

		while (carousel.firstChild) {
			carousel.removeChild(carousel.firstChild);
		}

		// Add wrapper to carousel

		carousel.appendChild(wrapper);

		// Add navigation/pagination if needed

		if (carousel.classList.contains("has-arrows")) {
			const nextBtn = document.createElement("div");
			const prevBtn = document.createElement("div");

			nextBtn.className = "swiper-button-next";
			prevBtn.className = "swiper-button-prev";

			carousel.appendChild(nextBtn);
			carousel.appendChild(prevBtn);
		}

		if (carousel.classList.contains("has-dots")) {
			const pagination = document.createElement("div");

			pagination.className = "swiper-pagination";

			carousel.appendChild(pagination);
		}

		// Swiper options

		let swiperOptions = {
			loop: carousel.classList.contains("is-infinite"),
			direction: carousel.classList.contains("is-vertical")
				? "vertical"
				: "horizontal",
			autoplay: carousel.classList.contains("will-autoplay")
				? bds_theme.features.carousels.swiper_opts.autoplay
				: false,
			effect: carousel.classList.contains("will-fade") ? "fade" : "slide",
			navigation: carousel.classList.contains("has-arrows")
				? {
						nextEl: carousel.querySelector(".swiper-button-next"),
						prevEl: carousel.querySelector(".swiper-button-prev"),
					}
				: false,
			pagination: carousel.classList.contains("has-dots")
				? {
						el: carousel.querySelector(".swiper-pagination"),
						clickable: true,
					}
				: false,
			speed: bds_theme.features.carousels.swiper_opts.speed,
		};

		// Fade effect options

		if (carousel.classList.contains("will-fade")) {
			swiperOptions.fadeEffect = bds_theme.features.carousels.swiper_opts.fade_effect;
		}

		// Determine slidesPerView and slidesPerGroup

		let slidesPerView = 1;
		let slidesPerGroup = 1;

		// Set slidesPerView from show-X

		for (let i = 1; i <= 6; i++) {
			if (carousel.classList.contains("show-" + i)) {
				slidesPerView = i;
			}
		}

		swiperOptions.slidesPerView = slidesPerView;

		// Set slidesPerGroup from scroll-X

		for (let i = 1; i <= 6; i++) {
			if (carousel.classList.contains("scroll-" + i)) {
				slidesPerGroup = i;
			}
		}

		swiperOptions.slidesPerGroup = slidesPerGroup;

		// Initialize Swiper

		new Swiper(carousel, swiperOptions);
	});
});
